import { useEffect } from 'react';

import { useAppSelector } from 'app/hooks';
import { selectOpen } from 'common/components/EditDrawer/editDrawerSlice';
import { Operations } from 'common/types/TypeDefs';

import { RequiredEditFieldsWIthAutoRenewalDiasbled, RequiredEditFieldsWIthAutoRenewalEnabled } from '../ILicenseCreateDrawerContent';
import { _isEditFormEnabled, _validateRequiredFieldsOnCreateEdit } from '../LicenseCreateEditHelpers';

export function useValidateRequiredLicenseFieldsOnEdit(
    requiredFieldsWithAutoRenewalEnabled: RequiredEditFieldsWIthAutoRenewalEnabled,
    requiredFieldsWithAutoRenewalDisabled: RequiredEditFieldsWIthAutoRenewalDiasbled,
    isDateValidationError: boolean,
    duplicatedCibsNotConfirmed: boolean,
    currentOperation?: Operations,
    isLicenseAutoRenewalEnabled?: boolean
): void {
    const isOpenDrawer = useAppSelector(selectOpen);

    useEffect(() => {
        if(currentOperation && _isEditFormEnabled(currentOperation, isOpenDrawer)) {
            if(isLicenseAutoRenewalEnabled) {
                const { startDate, billingRecord, billingSystemId } = requiredFieldsWithAutoRenewalEnabled;

                _validateRequiredFieldsOnCreateEdit<RequiredEditFieldsWIthAutoRenewalEnabled>(
                    {
                        startDate, billingRecord, billingSystemId
                    },
                    isDateValidationError,
                    duplicatedCibsNotConfirmed
                );
            } else {
                const { startDate, endDate, billingRecord, billingSystemId } = requiredFieldsWithAutoRenewalDisabled;

                _validateRequiredFieldsOnCreateEdit<RequiredEditFieldsWIthAutoRenewalDiasbled>(
                    {
                        startDate, endDate, billingRecord, billingSystemId
                    },
                    isDateValidationError,
                    duplicatedCibsNotConfirmed
                );
            }
        }
    }, [currentOperation,
        isOpenDrawer,
        requiredFieldsWithAutoRenewalEnabled.startDate,
        requiredFieldsWithAutoRenewalEnabled.billingSystemId,
        requiredFieldsWithAutoRenewalEnabled.billingRecord,
        requiredFieldsWithAutoRenewalDisabled.startDate,
        requiredFieldsWithAutoRenewalDisabled.endDate,
        requiredFieldsWithAutoRenewalDisabled.billingSystemId,
        requiredFieldsWithAutoRenewalDisabled.billingRecord,
        isLicenseAutoRenewalEnabled,
        isDateValidationError,
        duplicatedCibsNotConfirmed]);
}
